module.exports = __webpack_public_path__ + "img/9.3ab774d0.png";